import { render, staticRenderFns } from "./goldsilverinreturnHistory.vue?vue&type=template&id=2e46e3cc&scoped=true&"
import script from "./goldsilverinreturnHistory.vue?vue&type=script&lang=js&"
export * from "./goldsilverinreturnHistory.vue?vue&type=script&lang=js&"
import style0 from "./goldsilverinreturnHistory.vue?vue&type=style&index=0&id=2e46e3cc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e46e3cc",
  null
  
)

export default component.exports